import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface CreateAccreditationRequest {
  studentRef: string;
  type: string;
  date: string;
  eventType?: string;
  hoursPerformed?: number;
  quantity?: number;
  participantsCount?: number;
  animalsEnrolled?: number;
  infrastructureAvailable?: boolean;
  reactionsCount?: number;
  donationAmount?: number;
  hoursAccredited?: number;
  trialStartDate?: string;
  trialEndDate?: string;
  comments?: string;
  activityRef?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccreditationService {
  private http = inject(HttpClient);

  private baseUrl = `${environment.apiUrl}/accreditation`;

  createAccreditation(data: CreateAccreditationRequest) {
    return this.http.post(this.baseUrl, data);
  }

  approveAccreditation(id: string) {
    return this.http.patch(`${this.baseUrl}/${id}/approve`, {});
  }

  rejectAccreditation(id: string) {
    return this.http.patch(`${this.baseUrl}/${id}/reject`, {});
  }

  assignManualHours(id: string, hours: number) {
    return this.http.patch(
      `${this.baseUrl}/${id}/manual-hours`,
      { hours },
    );
  }

  getStudentAccreditations(studentId: string) {
    return this.http.get(
      `${this.baseUrl}/student/${studentId}`,
    );
  }

  getAllAccreditations() {
    return this.http.get(
      this.baseUrl,
    );
  }
}